import { FormHTMLAttributes } from "react";

import { Box, TextField } from "@mui/material";
import Grid, { GridProps, GridSize } from "@mui/material/Grid";
import { TextFieldProps } from "@mui/material/TextField";
import { SxProps } from "@mui/system";

type InputType = "text" | "email" | "number";
interface IContainerProps extends FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
  gridProps?: GridProps;
  sx?: SxProps;
}
interface IFormProps {
  inputs: IInput[];
  size?: "small" | "medium";
  gridSize?: GridSize;
  data?: { [key: string]: any } | null;
  setData?: React.Dispatch<React.SetStateAction<any>>;
}
export interface IInput {
  name: string;
  label: string;
  type?: InputType;
  inputProps?: TextFieldProps;

  gridSize?: { [key: string]: GridSize };
}

const FormContainer = function (props: IContainerProps) {
  const { children, gridProps, sx } = props;

  return (
    <Box component="form" sx={sx} {...props}>
      <Grid container {...gridProps}>
        {children}
      </Grid>
    </Box>
  );
};

const Form = function ({ inputs, gridSize, size, data = {}, setData }: IFormProps) {
  const handleSetData = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!setData) return;
    const { name, value } = event.target;
    setData((prev: typeof data) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      {inputs.map((input) => (
        <Grid item xs={gridSize} {...input.gridSize} key={input.name}>
          <TextField
            label={input.label}
            name={input.name}
            onChange={handleSetData}
            value={data ? data[input.name as keyof typeof data] : ""}
            size={size}
            fullWidth
            {...input.inputProps}
          />
        </Grid>
      ))}
    </>
  );
};

export { FormContainer, Form };
